import { useEffect, useState } from "react"

import { Alert, App, Flex, Segmented, Spin, Switch, Typography } from "antd"
import { useDispatch, useSelector } from "react-redux"

import ButtonComponent from "../../../../../Components/Button"
import InputNumberComponent from "../../../../../Components/Input/InputNumber"
import SelectComponent from "../../../../../Components/Select"
import { modalConfig } from "../../../../../theme"
import { PRICING_TAB } from "../../../../PricingPage/redux/pricing.constants"
import {
  selectAllPricingSchemes,
  selectAllPricingSchemesFetching
} from "../../../../PricingPage/redux/pricing.slice"
import { getAllPricingSchemes } from "../../../../PricingPage/redux/pricing.thunks"
import { userActions } from "../../../../User/redux/user.slice"
import { updateUserPrice } from "../../../../User/redux/user.thunks"
import PriceLevels from "./components/PriceLevels"

import styles from "../../styles.module.less"

const { Text } = Typography

const PRICE_LEVELS = [
  { field: "ethoca_price_levels", label: "Ethoca price levels" },
  { field: "rdr_1_price_levels", label: "RDR price" },
  { field: "cdrn_price_levels", label: "CDRN price" }
]

const FIXED_PRICES = [
  { field: "ethoca_price", label: "Ethoca price ($)" },
  { field: "rdr_1_price", label: "RDR price ($)" },
  { field: "cdrn_price", label: "CDRN price ($)" }
]

const AlertsTab = () => {
  const { modal } = App.useApp()
  const dispatch = useDispatch()

  const isMobile = useSelector((state) => state.nav.isMobile)
  const businessAccount = useSelector((state) => state.user.businessAccount)
  const saveFetching = useSelector((state) => state.user.saveFetching)
  const pricing = useSelector(selectAllPricingSchemes)
  const fetching = useSelector(selectAllPricingSchemesFetching)

  const [newPrice, setNewPrice] = useState(null)

  useEffect(() => {
    dispatch(userActions.userSaveResultReset())
    dispatch(getAllPricingSchemes())
  }, [dispatch])

  useEffect(() => {
    if (businessAccount?.pricing) setNewPrice(businessAccount.pricing)
  }, [businessAccount])

  const priceData = pricing.find(({ id }) => id === newPrice) || {}

  const options = pricing.map(({ id, pricing_schema }) => ({ value: id, label: pricing_schema }))

  const isSaved = businessAccount?.pricing === newPrice

  const handleSave = () => {
    if (isSaved) return

    modal.confirm({
      ...modalConfig("exclamation"),
      centered: !isMobile,
      title: "Save pricing settings",
      content:
        "Are you sure you want to save and apply these prices? If you proceed, new pricing scheme and prices will be applied for all alerts in the next invoice for this business account.",
      cancelText: "Cancel",
      okText: "Save and apply",
      onOk: () => dispatch(updateUserPrice({ ba_id: businessAccount.id, pricing: newPrice }))
    })
  }

  return (
    <Spin size="large" spinning={fetching || saveFetching}>
      <Flex vertical={true} gap={30} className={styles.form}>
        <Flex gap={24} className={styles.selectRow}>
          <SelectComponent
            value={newPrice}
            placeholder="Select a pricing scheme type"
            onChange={setNewPrice}
            options={options}
            className={"like-input"}
            style={{ width: "100%" }}
          />

          <ButtonComponent href={`/pricing?tab=${PRICING_TAB.ALERTS}`}>Edit</ButtonComponent>
        </Flex>

        <Segmented
          options={["Fixed", "Volume based"]}
          name="type"
          size="large"
          block
          value={priceData.type}
          disabled={true}
          className={styles.schemeType}
        />

        <Alert
          type="info"
          icon={<Switch checked={priceData.is_applied_from_scratch} disabled={true} />}
          message={<Text strong>Prices listed below are applied from scratch</Text>}
          description={
            <Text type="secondary">
              The next received alert will be considered as the first alert in the volume
            </Text>
          }
          showIcon
        />

        <Flex gap={24} align="center">
          <Text className={styles.label}>Number of the first alerts to skip</Text>
          <InputNumberComponent
            size="small"
            value={priceData.count_of_free_alerts}
            disabled={true}
            className={styles.value}
          />
        </Flex>

        {priceData.type === "Volume based"
          ? PRICE_LEVELS.map(({ field, label }) => (
              <PriceLevels
                key={field}
                label={label}
                levels={priceData[field]}
                freeCount={priceData.count_of_free_alerts}
              />
            ))
          : FIXED_PRICES.map(({ field, label }) => (
              <Flex gap={24} align="center" key={field}>
                <Text className={styles.label}>{label}</Text>
                <InputNumberComponent
                  size="small"
                  precision={2}
                  value={priceData[field]}
                  disabled={true}
                  className={styles.value}
                />
              </Flex>
            ))}
      </Flex>

      <Flex gap={16} justify="end" className={styles.actions}>
        <ButtonComponent size="large" type="primary" disabled={isSaved} onClick={handleSave}>
          Save and apply pricing
        </ButtonComponent>
      </Flex>
    </Spin>
  )
}

export default AlertsTab
